// Create the SVG element
const svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
svgElement.setAttribute("class", "Icon Icon--select-arrow");
svgElement.setAttribute("role", "presentation");
svgElement.setAttribute("viewBox", "0 0 19 12");

const polyline = document.createElementNS("http://www.w3.org/2000/svg", "polyline");
polyline.setAttribute("fill", "none");
polyline.setAttribute("stroke", "currentColor");
polyline.setAttribute("points", "17 2 9.5 10 2 2");
polyline.setAttribute("fill-rule", "evenodd");
polyline.setAttribute("stroke-width", "2");
polyline.setAttribute("stroke-linecap", "square");

svgElement.appendChild(polyline);

// Function to insert the SVG
function insertSVG(targetElement) {
  if (targetElement.firstChild) {
    targetElement.insertBefore(svgElement, targetElement.firstChild);
  } else {
    targetElement.appendChild(svgElement);
  }
}

// Create a MutationObserver instance
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE && 
            node.classList.contains('rc-selling-plans') && 
            node.classList.contains('rc_widget__option__plans')) {
          insertSVG(node);
          observer.disconnect(); // Stop observing once we've inserted the SVG
        }
      });
    }
  });
});

// Start observing the document with the configured parameters
observer.observe(document.body, { childList: true, subtree: true });



document.addEventListener('DOMContentLoaded', function () {
  const button = document.querySelector('.join-the-crew-button');
  const carousel = document.querySelector('.jdgm-carousel-wrapper');

  if (button && carousel) {
    button.insertAdjacentElement('afterend', carousel);
  }
});
